import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useMusicGate } from '@/context/MusicGateContext';

export const Visuals = () => {
    const { unlocked } = useMusicGate();

    return (
        <section
            data-testid="music-preview-section"
            className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-brand-surface"
        >
            <div className="max-w-7xl mx-auto">
                <div className="flex justify-between items-end mb-12">
                    <div>
                        <p className="font-mono text-xs text-brand-primary uppercase tracking-widest mb-4">NOW PLAYING</p>
                        <h2 className="font-syne font-bold text-4xl md:text-5xl text-white tracking-tight">
                            LATEST RELEASE
                        </h2>
                    </div>
                    <Link to="/music" className="hidden md:block">
                        <Button
                            variant="ghost"
                            className="text-slate-400 hover:text-white uppercase tracking-widest"
                        >
                            ALL MUSIC <ArrowRight className="w-4 h-4 ml-2" />
                        </Button>
                    </Link>
                </div>

                {/* SoundCloud Embed (mounted only after autoplay unlock) */}
                <div className="music-embed-container mb-8" data-testid="soundcloud-embed-container">
                    {unlocked && (
                        <iframe
                            width="100%"
                            height="166"
                            scrolling="no"
                            frameBorder="no"
                            allow="autoplay"
                            src="https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/tizzlestillfaded&color=%2394A3B8&auto_play=true&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&shuffle=true"
                            title="SoundCloud Player"
                            data-testid="soundcloud-embed"
                        />
                    )}
                </div>

                {/* Apple Music Embed */}
                <div className="music-embed-container">
                    <iframe
                        allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
                        frameBorder="0"
                        height="175"
                        style={{ width: '100%', overflow: 'hidden', borderRadius: '10px' }}
                        sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
                        src="https://embed.music.apple.com/us/artist/faded-keenan/1671435655"
                        title="Apple Music Player"
                        data-testid="apple-music-embed"
                    />
                </div>

                {/* Visuals / Music Videos */}
                <div className="mt-16">
                    <p className="font-mono text-xs text-brand-primary uppercase tracking-widest mb-4">WATCH</p>
                    <h3 className="font-syne font-bold text-2xl md:text-3xl text-white tracking-tight mb-8">
                        VISUALS
                    </h3>
                    <div className="space-y-6">
                        {/* Featured: No Sleep */}
                        <div className="aspect-video bg-brand-highlight border border-white/5 overflow-hidden" data-testid="home-music-video-1">
                            <iframe
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/5A05lLB33Zk"
                                title="Faded Keenan - No Sleep"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            />
                        </div>
                        <div className="grid md:grid-cols-2 gap-6">
                            <div className="aspect-video bg-brand-highlight border border-white/5 overflow-hidden" data-testid="home-music-video-2">
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src="https://www.youtube.com/embed/u9lkt4YcXpI"
                                    title="Faded Keenan Music Video"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                />
                            </div>
                            <div className="aspect-video bg-brand-highlight border border-white/5 overflow-hidden" data-testid="home-music-video-3">
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src="https://www.youtube.com/embed/4etCs321F0s"
                                    title="Faded Keenan Music Video"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <Link to="/music" className="md:hidden mt-8 block">
                    <Button
                        variant="outline"
                        className="w-full bg-transparent border border-white/20 text-white hover:bg-white/10 rounded-none py-4 uppercase tracking-widest"
                    >
                        ALL MUSIC <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                </Link>
            </div>
        </section>
    );
};
